<template>
  <div style="height: 100%">
    <sys-menu ref="sysMenu"></sys-menu>
    <center id="center">
      <top v-on:child-say="listenMore" ref="top"></top>
      <!-- <router-view
      ></router-view> -->
      <template>
        <keep-alive><router-view v-if="$route.meta.keepAlive"> </router-view></keep-alive>
        <router-view v-if="!$route.meta.keepAlive"> </router-view>
      </template>

      <!-- https://segmentfault.com/a/1190000022829758 -->
      <!-- inlcude包含该组件就缓存，exclude不包含该组件就缓存，二者都可以用逗号分隔字符串、正则表达式或一个数组来表示 -->
    </center>
  </div>
</template>
<script>
import sysMenu from "../../node_modules/common/src/components/sys/sysMenu.vue";
import top from "../../node_modules/common/src/components/sys/top.vue";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      platConfig: null,
    };
  },
  components: {
    sysMenu,
    top,
  },
  methods: {
    listenMore(t) {
      this.more = t;
    },
    reload() {
      this.isShow = false;
      this.$nextTick(function () {
        this.isShow = true;
      });
    },

    getDiaodu() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/pendingList",
        data: {
          keyword: "",
          pageNumber: 1,
          pageSize: 1,
          startTime: 0,
          endTime: Date.now(),
        },
      }).then((res) => {
        var total = res.data.data.total;
        this.$store.state.dots["调度中心"] = total;
        this.$store.state.dots["待办流程"] = total;
      });
    },
    citymap() {
      AMap.plugin("AMap.DistrictSearch", function () {
        var districtSearch = new AMap.DistrictSearch({
          level: "country", //关键字对应的行政区级别，country 表示国家
          subdistrict: 1, //显示下级行政区级数，1表示返回下一级行政区
          extensions: 'all', //返回行政区边界坐标组等具体信息
        });
        //搜索所有省、直辖市信息
        districtSearch.search("中国", function (status, result) {
          console.log(status, result);
          //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
          //查询成功时，result 即为对应的行政区信息
        });
      });
    }
    //websock
  },
  created() { },
  destroyed() {
    //websock.close(); //离开路由之后断开websocket连接
    //this.alarms = [];
  },
  mounted() {
    //this.$refs.sysMenu.getMenu();
    //this.$refs.top.reachData();
    this.getDiaodu();
  },
};
</script>
<style lang="">
#reLink {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2222;
  background: rgba(0, 0, 0, 0.3);
}
#reLinkson {
  margin: 100px auto;
  width: 300px;
  background: #fff;
  padding: 20px;
}
#reLinkson h2 {
  font-size: 18px;
  margin-bottom: 10px;
}
#reLinkson p {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue